import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { useCallback } from "react";
import { useAlert } from "react-alert";
import { useRestoreCandidateMutation } from "../../redux/Hire/jobRequestApi";
import { CloseIcon } from "../../shared/components/Icons";

type Props = {
  showModal: boolean;
  onClose: () => void;
  candidateName: string;
  candidateId: number;
  stage: string;
  jobId: number;
  positiveResponse?: () => void;
};

const RestoreCandidateModal = ({
  showModal,
  onClose,
  candidateId,
  candidateName,
  stage,
  jobId,
  positiveResponse,
}: Props) => {
  const [restoreCandidate, restoreCandidateMutating] =
    useRestoreCandidateMutation();
  const alert = useAlert();
  const onClick = useCallback(async () => {
    try {
      await restoreCandidate({
        candidateId: candidateId,
        jobId: jobId.toString(),
        stageCode: stage,
      }).unwrap();
      alert.success("Candidate restored to current stage successfully");
      positiveResponse?.();
    } catch {
      alert.error("Error while restoring candidate");
      onClose();
    }
  }, [
    alert,
    candidateId,
    jobId,
    onClose,
    positiveResponse,
    restoreCandidate,
    stage,
  ]);

  return (
    <Dialog open={showModal} onClose={onClose} maxWidth="md">
      <DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          px: 4,
          my: 2,
        }}
      >
        <Grid container direction={"column"} item>
          <Typography
            fontSize={"24px"}
            lineHeight={"32px"}
            fontWeight={"700"}
            align="center"
          >
            Are you sure you want to restore the candidate
            {candidateName ? ` ${candidateName}?` : "?"}
          </Typography>
          <Grid container justifyContent={"flex-end"} gap={1} item>
            <Button variant="text" sx={{ mt: 2 }} onClick={onClose}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{ mt: 2 }}
              onClick={onClick}
              disabled={restoreCandidateMutating.isLoading}
            >
              {restoreCandidateMutating.isLoading ? (
                <CircularProgress size={20}></CircularProgress>
              ) : (
                "Restore"
              )}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default RestoreCandidateModal;
